var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 这是测试 --转帐 "),_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.transfer}},[_vm._v("提交")]),_c('br'),_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.getStates}},[_vm._v("信息")]),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }